import en from "./en.json";
import fr from "./fr.json";
import es from "./es.json";
import ca from "./ca.json";
import de from "./de.json";
import ro from "./ro.json";
import he from "./he.json";
import ru from "./ru.json";
import pt from "./pt.json";
import ja from "./ja.json";
import zh from "./zh.json";
import it from "./it.json";

export { en, fr, es, ca, de, ro, he, ru, pt, ja, zh, it };
